<template>
    <div class="kgk-login-form">
        <h1>Anmelden</h1>

        <form @submit.prevent="performLogin">
            <div class="kgk-form-row">
                E-Mail<!-- / Username-->
                <div class="kgk-input-group">
                    <div class="kgk-input-group-prepend"><i class="fas fa-envelope fa-fw"></i></div>
                    <input type="email" required v-model="user" name="email" style="padding-right: 48px">
                </div>
            </div>
            <div class="kgk-form-row">
                Passwort
                <div class="kgk-input-group">
                    <div class="kgk-input-group-prepend"><i class="fas fa-key fa-fw"></i></div>
                    <input type="password" required v-model="password" name="password" style="padding-right: 48px">
                </div>
            </div>
            <div class="kgk-form-row">
                <input type="submit" value="Anmelden">
            </div>
        </form>

        <div v-if="loading" class="kgk-loading-indicator"><i class="fas fa-spinner fa-spin"></i></div>
        <!--<div v-else-if="error">
            <div class="kgk-form-row">Fehler: {{error}}</div>
        </div>-->
    </div>
</template>

<script>
    import sessionHandling from '../../session-handling';
    import session from '../../api/session';
    import router from '../../router';

    export default {
        name: 'LoginForm',
        props: {
            //msg: String
        },
        data() {
            return {
                loading: false,
                error: false,
                user: '',
                password: ''
            }
        },
        mounted() {

        },
        methods: {
            performLogin: function() {
                this.loading = true;

                session.tryLogin(
                    this,
                    this.user,
                    this.password,
                    data => {
                        this.error = false;

                        sessionHandling.login(data.session_token);
                        // App.vue's shared user (used by e.g. SyncStrava/CreateRun
                        // via $parent.user) is only ever populated on app boot, and
                        // login doesn't remount the app -- refresh it explicitly so
                        // components relying on it reflect the just-logged-in user.
                        this.$parent.$parent.loadUserDetails();

                        this.$notify({
                            type: 'success',
                            title: 'Hallo ' + data.user.prename + '!',
                            text: 'Du hast dich erfolgreich angemeldet.'
                        });

                        if(this.$parent.$parent.redirectAfterLogin){
                            router.push(this.$parent.$parent.redirectAfterLoginTo);
                        }else{
                            router.push('/runs');
                        }
                    },
                    e => {
                        if( e.response.status == 403 ) {
                            this.error = 'Account nicht aktiviert';

                            this.$notify({
                                type: 'error',
                                title: 'Account nicht aktiviert',
                                text: 'Bitte schalte deinen Account einmalig über den via E-Mail erhaltenen Link frei. Danach kannst du dich anmelden.'
                            });

                            return;
                        }

                        if( e.response.status == 422 ) {
                            this.error = 'Zugangsdaten fehlerhaft.';

                            this.$notify({
                                type: 'error',
                                title: 'Zugangsdaten fehlerhaft.',
                                text: 'Bitte versuch es erneut.'
                            });

                            return;
                        }

                        if (e.response && e.response.status == 401) {
                            this.error = 'Zugangsdaten fehlerhaft.';
                            this.$notify({
                                type: 'error',
                                title: 'Zugangsdaten fehlerhaft.',
                                text: 'Benutzername oder Passwort ist falsch.'
                            });
                            return;
                        }

                        this.error = 'Unbekannter Fehler.';
                        this.$notify({
                            type: 'error',
                            title: 'Unbekannter Fehler.',
                            text: 'Bitte versuch es erneut.'
                        });
                    },
                    () => this.loading = false,
                );
            }
        }
    }
</script>
